/**
 * @generated SignedSource<<299378e135d26ad191cc4ef4e6daa1e5>>
 * @relayHash ad67d5c638a8acc9d4003765d0397a6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 516eb1b00ced578ccb8d76a05a78f14c226100c34ec3f6ed6f857e097f2c3089

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type RealtimeUpdater_issueDeletedSubscription$variables = {
  cloudId: string;
  projectId: string;
};
export type RealtimeUpdater_issueDeletedSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProject: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RealtimeUpdater_issueDeletedSubscription = {
  response: RealtimeUpdater_issueDeletedSubscription$data;
  variables: RealtimeUpdater_issueDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProject",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RealtimeUpdater_issueDeletedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RealtimeUpdater_issueDeletedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "516eb1b00ced578ccb8d76a05a78f14c226100c34ec3f6ed6f857e097f2c3089",
    "metadata": {},
    "name": "RealtimeUpdater_issueDeletedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "90663a45b8a3ab86b08b962bd7ce7670";

export default node;
